import React from 'react';
import { InputAdornment } from '@material-ui/core';
import withStyles from "@material-ui/core/styles/withStyles";

import PersonAdd from '@material-ui/icons/PersonAdd';
import Mail from '@material-ui/icons/Mail';
import Add from '@material-ui/icons/Add';
import Phone from '@material-ui/icons/Phone';

import Loading from '../../components/Loading/Loading';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Api from '../../api/Api.js';
import UserEndpoints from '../../api/UserEndpoints';
import { store } from '../../redux/store';
import { push } from 'connected-react-router';
import { ADD_TO_USER_LIST } from '../../redux/types';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    },
    userHeader: {
        marginTop: 20,
        marginLeft: 20,
    }
};

const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
}

const verifyUsername = (value) => {
    var usernameRex = /^[a-zA-Z0-9_\-.]{1,255}$/;
    if (usernameRex.test(value)) {
        return true;
    }
    return false;
}

class AddUser extends React.Component {

    state = {
        loading: false,

        username: "",
        usernameState: "",
        usernameAlreadyTaken: false,

        email: "",
        emailState: "",
        emailAlreadyTaken: false,

        role: 1,

        name: "",
        nameState: "",

        surname: "",
        surnameState: "",

        contact_number: "",
        contact_numberAlreadyTaken: false,

        description: ""
    }

    checkEmail() {
        const testEmail = this.state.email;

        Api.get(UserEndpoints.isEmailUsed, { email: testEmail })
            .then(({ data }) => {
                if (data == true) {
                    if (testEmail === this.state.email)
                        this.setState({ emailAlreadyTaken: true, emailState: 'error' })
                } else {
                    this.setState({ emailAlreadyTaken: false })
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    checkUsername() {
        const testUsername = this.state.username;

        Api.get(UserEndpoints.isUsernameUsed, { username: testUsername })
            .then(({ data }) => {
                if (data == true) {
                    if (testUsername === this.state.username)
                        this.setState({ usernameAlreadyTaken: true, usernameState: 'error' })
                } else {
                    this.setState({ usernameAlreadyTaken: false })
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    checkContactNumber() {
        const testNumber = this.state.contact_number;

        Api.get(UserEndpoints.isContactNumberUsed, { contact_number: testNumber })
            .then(({ data }) => {
                if (data == true) {
                    if (testNumber === this.state.contact_number)
                        this.setState({ contact_numberAlreadyTaken: true })
                } else {
                    this.setState({ contact_numberAlreadyTaken: false })
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    submit() {
        if (
            this.state.usernameState === "success"
            &&
            this.state.emailState === "success"
            &&
            this.state.nameState === "success"
            &&
            this.state.surnameState === "success"
            && 
            !this.state.contact_numberAlreadyTaken
        ) {
            Api.post(UserEndpoints.add, this.state)
                .then(({ data }) => {
                    console.log(data);

                    //TODO: Redirect to user page
                    store.dispatch({ type: ADD_TO_USER_LIST, payload: data });
                    store.dispatch(push("/users/view/" + data.id));
                })
                .catch((e) => {
                    console.error(e);
                })
        }
        else {
            var newState = {};

            if (this.state.usernameState !== "success") {
                newState.usernameState = "error";
            }
            if (this.state.emailState !== "success") {
                newState.emailState = "error";
            }
            if (this.state.nameState !== "success") {
                newState.nameState = "error";
            }
            if (this.state.surnameState !== "success") {
                newState.surnameState = "error";
            }

            this.setState(newState);
        }
    }

    render() {

        const { classes } = this.props;

        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8} lg={6} xl={4}>
                    <Card>
                        <h3 className={classes.userHeader}>
                            <PersonAdd />&nbsp;&nbsp;New User
                        </h3>

                        {/* <CardBody>
                            <h4>
                                New User
                            </h4>
                        </CardBody> */}
                        <CardBody>
                            <CustomInput
                                success={this.state.usernameState === "success"}
                                error={this.state.usernameState === "error"}
                                labelText={
                                    <span>
                                        {this.state.usernameAlreadyTaken ? "Username Already Taken" : "Username"} <small>(required and unique)</small>
                                    </span>
                                }
                                id="username"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ username: event.target.value, usernameState: event.target.value && verifyUsername(event.target.value) ? "success" : "error" }, () => this.checkUsername()),
                                    // endAdornment: (
                                    //     <InputAdornment
                                    //         position="end"
                                    //         className={classes.inputAdornment}
                                    //     >
                                    //         <CardTravel className={classes.inputAdornmentIcon} />
                                    //     </InputAdornment>
                                    // ),
                                    value: this.state.username,
                                }}
                            />

                            <CustomInput
                                success={this.state.emailState === "success"}
                                error={this.state.emailState === "error"}
                                labelText={
                                    <span>
                                        {this.state.emailAlreadyTaken ? "Email Address Already Taken" : "Email Address"} <small>(required and unique)</small>
                                    </span>
                                }
                                id="email"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ email: event.target.value, emailState: event.target.value && verifyEmail(event.target.value) ? "success" : "error" }, () => this.checkEmail()),
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.inputAdornment}
                                        >
                                            <Mail className={classes.inputAdornmentIcon} />
                                        </InputAdornment>
                                    ),
                                    value: this.state.email,
                                }}
                            />

                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <InputLabel
                                    htmlFor="role"
                                    className={classes.selectLabel}
                                    shrink
                                >
                                    Role
                                </InputLabel>
                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={this.state.role}
                                    onChange={(event) => this.setState({ role: event.target.value })}
                                    inputProps={{
                                        name: "role",
                                        id: "role"
                                    }}
                                    color="rose"
                                >
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={1}>
                                        Client
                                    </MenuItem>

                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={2}>
                                        Sales
                                    </MenuItem>

                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={3}>
                                        Product Manager
                                    </MenuItem>

                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={4}>
                                        Operations
                                    </MenuItem>

                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={5}>
                                        Operations Manager
                                    </MenuItem>

                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={6}>
                                        Developer / Administrator
                                    </MenuItem>
                                </Select>
                            </FormControl>

                            <CustomInput
                                success={this.state.nameState === "success"}
                                error={this.state.nameState === "error"}
                                labelText={
                                    <span>
                                        Name <small>(required)</small>
                                    </span>
                                }
                                id="name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ name: event.target.value, nameState: event.target.value ? "success" : "error" }),
                                    // endAdornment: (
                                    //     <InputAdornment
                                    //         position="end"
                                    //         className={classes.inputAdornment}
                                    //     >
                                    //         <CardTravel className={classes.inputAdornmentIcon} />
                                    //     </InputAdornment>
                                    // ),
                                    value: this.state.name,
                                }}
                            />

                            <CustomInput
                                success={this.state.surnameState === "success"}
                                error={this.state.surnameState === "error"}
                                labelText={
                                    <span>
                                        Surname <small>(required)</small>
                                    </span>
                                }
                                id="name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ surname: event.target.value, surnameState: event.target.value ? "success" : "error" }),
                                    // endAdornment: (
                                    //     <InputAdornment
                                    //         position="end"
                                    //         className={classes.inputAdornment}
                                    //     >
                                    //         <CardTravel className={classes.inputAdornmentIcon} />
                                    //     </InputAdornment>
                                    // ),
                                    value: this.state.surname,
                                }}
                            />

                            <CustomInput
                                labelText={
                                    <span>
                                        {this.state.contact_numberAlreadyTaken ? "Contact Number Already Taken" : "Contact Number"} <small>(optional and unique)</small>
                                    </span>
                                }
                                error={this.state.contact_numberAlreadyTaken}
                                id="contact_number"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ contact_number: event.target.value }),
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.inputAdornment}
                                        >
                                            <Phone className={classes.inputAdornmentIcon} />
                                        </InputAdornment>
                                    ),
                                    value: this.state.contact_number,
                                }}
                            />

                            <CustomInput
                                labelText={
                                    <span>
                                        Description <small>(optional)</small>
                                    </span>
                                }
                                id="description"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ description: event.target.value }),
                                    // endAdornment: (
                                    //     <InputAdornment
                                    //         position="end"
                                    //         className={classes.inputAdornment}
                                    //     >
                                    //         <CardTravel className={classes.inputAdornmentIcon} />
                                    //     </InputAdornment>
                                    // ),
                                    value: this.state.description,
                                }}
                            />
                        </CardBody>
                        <CardFooter style={{ justifyContent: 'center' }}>
                            {
                                this.state.loading ?
                                    <div style={{ paddingBottom: 10 }}>
                                        <Loading />
                                    </div>
                                    :
                                    <Button color="rose" onClick={() => this.submit()} round>
                                        Add User
                                        &nbsp;&nbsp;
                                        <Add />
                                    </Button>
                            }
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(AddUser);